import { render } from "./HomeView.vue?vue&type=template&id=3c7cdf3c&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=3c7cdf3c&lang=css"
import "./HomeView.vue?vue&type=style&index=1&id=3c7cdf3c&lang=scss&scoped=true"

import exportComponent from "/var/www/easymp/data/www/easymp.ru/src/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7cdf3c"]])

export default __exports__